import { render, staticRenderFns } from "./PacketaSelectedPoint.vue?vue&type=template&id=7561c8f9"
import script from "./PacketaSelectedPoint.vue?vue&type=script&lang=js"
export * from "./PacketaSelectedPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports